import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { QueryParamsEntitiesV3 } from "./MainApp";
import { getHubData } from "@/app/infrastructures/misc/Cookies";

export class HangingPosBkdListRequest {
  search = "";
  days = "";
  existenceStatus = "";
  statusFollowUp = "";
  hubId = 0;

  constructor(fields?: Partial<HangingPosBkdListRequest>) {
    Object.assign(this, fields);

    if (getHubData().hubId) {
      this.hubId = Number(getHubData().hubId);
    }
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(ConvertObjectCamelToSnakeCaseV2(this))
      .queryString;
  }
}

export class HangingListFollowUp {
  partnerType = "";
  partnerCode = "";
  partnerName = "";
  username = "";

  constructor(fields?: Partial<HangingListFollowUp>) {
    Object.assign(this, fields);
  }
}

export class GroupSummaryLastMile {
  totalManifest = 0;
  totalStt = 0;

  constructor(fields?: Partial<GroupSummaryLastMile>) {
    Object.assign(this, fields);
  }
}

export class GroupSttsLastMile {
  no = 0;
  noManifest = "";
  sttNo = "";
  isAggregator = false;
  hangingDays = 0;
  existenceStatus = "";
  existenceLocation = "";
  existenceLocationnote = "";
  existenceUsername = "";
  existenceFindAt = "";
  isChecked = false;

  constructor(fields?: Partial<GroupSttsLastMile>) {
    Object.assign(this, fields);
  }
}

export class HangingListGroupsStt {
  no = 0;
  noManifest = "";
  sttNo = "";
  isAggregator = false;
  hangingDays = 0;
  productType = "";
  destination = "";
  existenceStatus = "";
  existenceLocation = "";
  existenceLocationnote = "";
  existenceUsername = "";
  existenceFindAt = "";
  isChecked = false;

  constructor(fields?: Partial<HangingListGroupsStt>) {
    Object.assign(this, fields);
  }
}

export class HangingListGroups {
  groupName = "";
  summary = new GroupSummaryLastMile();
  stts: HangingListGroupsStt[] = [];
  isChecked = false;

  constructor(fields?: Partial<HangingListGroups>) {
    Object.assign(this, fields);
  }
}

export class HangingList {
  activityId = 0;
  activityType = "";
  followUpStatus = "";
  followUp = new HangingListFollowUp();
  followUpByUsername = "";
  followUpAt = "";
  groups: HangingListGroups[] = [];
  isCollapsed = false;
  followUpById = 0;

  constructor(fields?: Partial<HangingList>) {
    Object.assign(this, fields);

    if (fields?.followUp) {
      this.followUp = new HangingListFollowUp(fields.followUp);
    }

    if (fields?.groups) {
      this.groups = fields.groups.map(
        (group: any) =>
          new HangingListGroups({
            ...group,
            summary: new GroupSummaryLastMile(group.summary),
            stts: group.stts.map((stt: any) => new HangingListGroupsStt(stt))
          })
      );
    }
  }
}
